import { observer } from "mobx-react-lite";
import { TCText } from "../../../components/TCText/TCText";
import { Colors } from "../../../utils/colors";
import { UserAvatar } from "../../../components/userAvatar/UserAvatar";
import { ComparisonProgress } from "./ComparisonProgress";
import { ComparisonOverlayLines } from "./ComparisonOverlayLines";
import { useMatchDetailsStore } from "../../../stores/StoreContext";
import { DownloadUltraAppOverlay } from "../../ultraPromo/components/DownloadUltraAppOverlay";

export const PairComparison = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div style={{ position: "relative" }}>
      <PairTextView />
      <PairAvatarView />
      <ComparisonOverlayLines top={40} bottom={10} />
      <ComparisonProgress />
      {matchDetailsStore.isPromoMode ? <DownloadUltraAppOverlay /> : null}
    </div>
  );
});

const PairTextView = () => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginTop: 30,
        marginLeft: 10,
        marginRight: 10,
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "baseline",
          gap: 5,
        }}>
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: Colors.white,
          }}
        />
        <TCText
          value="Pair 1"
          style={{
            color: Colors.white,
            opacity: 0.5,
            fontWeight: "500",
            fontSize: 10,
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "baseline",
          gap: 5,
        }}>
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: 4,
            backgroundColor: Colors.white,
          }}
        />
        <TCText
          value="Pair 2"
          style={{
            color: Colors.white,
            opacity: 0.5,
            fontWeight: "500",
            fontSize: 10,
          }}
        />
      </div>
    </div>
  );
};

const PairAvatarView = observer(() => {
  const matchDetailsStore = useMatchDetailsStore();
  return (
    <div
      style={{
        marginTop: 10,
        display: "flex",
        flexDirection: "row",
        marginLeft: 10,
        marginRight: 10,
      }}>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          justifyContent: "center",
        }}>
        <UserAvatar
          size={50}
          avatar={{
            image: matchDetailsStore.teamMates[0]?.userImageUrl ?? "",
            name: matchDetailsStore.teamMates[0]?.name ?? "",
          }}
        />
        <UserAvatar
          style={{
            marginLeft: -10,
          }}
          size={50}
          avatar={{
            image: matchDetailsStore.teamMates[1]?.userImageUrl ?? "",
            name: matchDetailsStore.teamMates[1]?.name ?? "",
          }}
        />
      </div>
      <div
        style={{
          display: "flex",
          flexDirection: "row",
          flex: 1,
          justifyContent: "center",
        }}>
        <UserAvatar
          size={50}
          avatar={{
            image: matchDetailsStore.opponents[0]?.userImageUrl ?? "",
            name: matchDetailsStore.opponents[0]?.name ?? "",
          }}
        />
        <UserAvatar
          style={{
            marginLeft: -10,
          }}
          size={50}
          avatar={{
            image: matchDetailsStore.opponents[1]?.userImageUrl ?? "",
            name: matchDetailsStore.opponents[1]?.name ?? "",
          }}
        />
      </div>
    </div>
  );
});
